import React from 'react';

// HELPER PROFESSIONALS
import RemoveMFA from 'components/MFA/RemoveMFA';
import ChangeAvatar from 'components/Avatar/ChangeAvatar';
import RealtorCompany from './Preview/RealtorCompany';
import { Box, HStack, Button, Icon } from '@chakra-ui/react';
import BackButton from 'components/Button/BackButton';
import RefreshIcon from 'components/icons/RefreshIcon';
// API CALLS
import { useGetRaltorDetailsQuery, useUpdateRealtorMutation } from 'reducers/realtor.service';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom';
import { CiEdit } from 'react-icons/ci';
// import { viewMobile } from 'utils/number';
import 'assets/css/viewlayout.scss';
import 'assets/css/Preview.css';
import ViewPersonal from 'components/Views/ViewPersonal';
import ChangeUserPassword from 'components/Action/ChangeUserPassword';
import RealtorCompanyForm from 'components/Forms/RealtorCompanyForm';
import { REALTOR_COMPANY_DEFAULTS } from 'constants/index';
import { mapResponseToDefaults } from 'utils/default-util';

const RealtorDetails = () => {
    const { id } = useParams();
    const { data, refetch , isFetching, isLoading } = useGetRaltorDetailsQuery(id);
    const mfaValue = data?.authData?.isTwoMfaEnable || false;
    const [updateRealtor] = useUpdateRealtorMutation();
    const deleteAvatar = ()=>{
        updateRealtor({ id , body: { avatar: null } }).unwrap().then(()=>{
            refetch();
        });
    };
    const history = useHistory();
    const searchparams = new URLSearchParams(history.location.search);
    const isRealtorEdit = searchparams.get('isRealtorEdit') === 'true';

    const handleRealtorCompnayEdit = ()=>{
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('isRealtorEdit', !isRealtorEdit);

        // history replace
        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    };

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'space-between' }}>
                <BackButton />
                <span>Back</span>
                <Box flex={1} textAlign={'end'}>
                    <RefreshIcon handleRefresh={ refetch}/>
                </Box>
            </div>

            <HStack
                width={'100%'}
                gap={'1rem'}
                mb="1rem"
                alignItems={'start'}
                mt={'1rem'}
            >

                <Box flex={1} p={4} borderRadius="lg" boxShadow="md" border="1px solid #E2E8F0" bg="white">
                    <ViewPersonal
                        data={data}
                        refetch={ refetch}
                        isLoading={isLoading}
                    />
                </Box>
                <Box
                    p="4"
                    h={'110vh'}
                    flex={1}
                    borderRadius="lg"
                    boxShadow="md"
                    border="1px solid #E2E8F0"
                    bg="white"
                >
                    <RemoveMFA
                        id={ id }
                        data={data}
                        mfaValue={mfaValue}
                        isFetching={ isFetching}
                        refetch={refetch}
                    />
                    <br />
                    <br />
                    <ChangeUserPassword data={data} refetch={refetch}/>
                </Box>
                <Box
                    p="4"
                    h={'110vh'}
                    flex={1}
                    borderRadius="lg"
                    boxShadow="md"
                    border="1px solid #E2E8F0"
                    bg="white"
                >
                    <ChangeAvatar
                        id={id}
                        data ={data}
                        refetch={refetch}
                        deleteAvatar={deleteAvatar}
                    />

                </Box>
            </HStack>
            <Box
                p="4"
                flex={1}
                borderRadius="lg"
                boxShadow="md"
                border="1px solid #E2E8F0"
                bg="white"
            >
                <div className="preview-heading space-between-box">
                    <p>
                                                    Company Details
                    </p>
                    <Button onClick={handleRealtorCompnayEdit} style={{ fontSize: '13px', color: 'teal' }}>
                        {
                            isRealtorEdit
                                ? <>
                                                            Cancel
                                </>
                                : <>
                                    <Icon as={CiEdit} w={4} h={4} mr={1} />
                                                                    Edit Company  Details
                                </>
                        }
                    </Button>
                </div>

                {
                    isRealtorEdit
                        ? <RealtorCompanyForm
                            data={data?.company}
                            defaultValues={mapResponseToDefaults(REALTOR_COMPANY_DEFAULTS , data?.company)}
                            isEdit={isRealtorEdit}
                            refetch={refetch}
                            setisEdit={handleRealtorCompnayEdit}
                        />
                        : <RealtorCompany
                            handleEdit={handleRealtorCompnayEdit}
                            refetch={refetch}
                            isLoading={isLoading}
                            data={data?.company}
                        />
                }

            </Box>

        </Box>
    );
};

export default RealtorDetails;
